import { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Modal, SelectPicker } from "rsuite";

import { selector } from "../../../api";
import { Divider } from "antd";
import { useNotification } from "../../../utils/notificationProvider";
import { appCRUD } from "../../../actions/app";
import { char } from "../../../utils";

const timetableSchema = Yup.object().shape({
  campus: Yup.number().required("Campus is required"),
  academicYear: Yup.number().required("Academic Year is required"),
  semester: Yup.number().required("Semester is required"),
});

const initialValues = {
  campus: "",
  academicYear: "",
  semester: "",
};

export const TimeTableAdd = (props) => {
  const { open, setOpen, index, setIndex } = props;
  const user = selector.User();
  const [loading, setLoading] = useState(false);
  const openNotification = useNotification();
  const [campus, setCampus] = useState([]);
  const [academicYears, setAcademicYears] = useState([]);
  const [semesters, setSemesters] = useState([]);
  const [searchCampus, setSearchCampus] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      appCRUD
        .loadCampas(50, 0, searchCampus, "name")
        .then((reps) => setCampus(reps.data.results || []))
        .catch(() => {});
    }, 300);
    return () => clearTimeout(timer);
  }, [searchCampus]);

  useEffect(() => {
    appCRUD
      .loadAcademic(50, 0, "", "-id")
      .then((resp) => setAcademicYears(resp.data.results || []))
      .catch(() => {});
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: timetableSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const data = {
        campus: parseInt(values.campus),
        academicYear: parseInt(values.academicYear),
        semester: parseInt(values.semester),
        recorder: parseInt(user?.id || 1),
      };

      setLoading(true);
      appCRUD
        .addTimeTable(data)
        .then(() => {
          openNotification("success", "Success", "Timetable created successfully!");
          setIndex(index + 1);
          resetForm();
          setLoading(false);
          setSubmitting(false);
          setOpen(false);
        })
        .catch((error) => {
          setLoading(false);
          setSubmitting(false);
          const msg =
            error.response?.data?.error ||
            error.response?.data?.detail ||
            "Something went wrong. Please try again.";
          openNotification("error", "Error", msg);
        });
    },
  });

  useEffect(() => {
    if (formik.values.academicYear) {
      const selectedYear = academicYears.find(
        (y) => y.academic_id === formik.values.academicYear
      );
      if (selectedYear) {
        appCRUD
          .loadSemister(50, 0, selectedYear.id, "", "-id")
          .then((resp) => setSemesters(resp.data.results || []))
          .catch(() => setSemesters([]));
      }
    } else {
      setSemesters([]);
    }
  }, [formik.values.academicYear, academicYears]);

  return (
    <Modal open={open} onClose={() => setOpen(false)} size="md">
      <Modal.Header>
        <Modal.Title>New Time Table</Modal.Title>
      </Modal.Header>
      <Divider />
      <form onSubmit={formik.handleSubmit}>
        <Modal.Body>
          <div className="container">
            <div className="row mb-3">
              <div className="col-12">
                <label className="text-body mb-2">
                  Campus <span className="text-danger">&nbsp;*</span>
                </label>
                <SelectPicker
                  className="w-100"
                  data={campus?.map((dt) => ({
                    value: dt.compas_id,
                    label: char.toTitleCase(dt.name),
                  }))}
                  value={formik.values.campus}
                  placeholder="Select Campus"
                  onChange={(e) => formik.setFieldValue("campus", e)}
                  onClean={() => formik.setFieldValue("campus", "")}
                  onSearch={(e) => setSearchCampus(e)}
                />
                {formik.touched.campus && formik.errors.campus && (
                  <div className="fw-light mt-1" style={{ fontSize: "12px" }}>
                    <span role="alert" className="text-danger">
                      {formik.errors.campus}
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-12">
                <label className="text-body mb-2">
                  Academic Year <span className="text-danger">&nbsp;*</span>
                </label>
                <SelectPicker
                  className="w-100"
                  data={academicYears.map((y) => ({
                    value: y.academic_id,
                    label: y.name,
                  }))}
                  value={formik.values.academicYear}
                  placeholder="Select Academic Year"
                  onChange={(e) => {
                    formik.setFieldValue("academicYear", e);
                    formik.setFieldValue("semester", "");
                  }}
                  onClean={() => {
                    formik.setFieldValue("academicYear", "");
                    formik.setFieldValue("semester", "");
                  }}
                />
                {formik.touched.academicYear && formik.errors.academicYear && (
                  <div className="fw-light mt-1" style={{ fontSize: "12px" }}>
                    <span role="alert" className="text-danger">
                      {formik.errors.academicYear}
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="row mb-3">
              <div className="col-12">
                <label className="text-body mb-2">
                  Semester <span className="text-danger">&nbsp;*</span>
                </label>
                <SelectPicker
                  className="w-100"
                  data={semesters.map((s) => ({
                    value: parseInt(s.code),
                    label: char.toTitleCase(s.name),
                  }))}
                  value={formik.values.semester}
                  placeholder={
                    formik.values.academicYear
                      ? "Select Semester"
                      : "Select Academic Year first"
                  }
                  disabled={!formik.values.academicYear}
                  onChange={(e) => formik.setFieldValue("semester", e)}
                  onClean={() => formik.setFieldValue("semester", "")}
                />
                {formik.touched.semester && formik.errors.semester && (
                  <div className="fw-light mt-1" style={{ fontSize: "12px" }}>
                    <span role="alert" className="text-danger">
                      {formik.errors.semester}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Divider style={{ marginTop: -10 }} />
        <Modal.Footer>
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-12 d-flex justify-content-start">
                <span className="fs-18 text-danger"> * &nbsp;</span> Required field
              </div>
              <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                <button
                  onClick={() => setOpen(false)}
                  type="button"
                  className="btn btn-soft-danger me-3"
                >
                  <i className="ri-close-circle-line align-middle fs-16 me-2"></i>
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-soft-success"
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && (
                    <span className="indicator-label">
                      <i className="ri-check-double-line align-middle fs-16 me-2"></i>
                      Save
                    </span>
                  )}
                  {loading && (
                    <span className="indicator-progress" style={{ display: "block" }}>
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
